import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useCallback } from 'react';
import { Box, Typography, ImageWithFallback } from '@applyboard/ui-components';
import { ArrowLeftOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
import { displayMobileOnly } from "../../consts";
import { Information, StyledLink, useStyle } from "./style";
export var SmallSchoolSummary = function SmallSchoolSummary(_ref) {
  var schoolName = _ref.schoolName,
    countryCode = _ref.countryCode,
    city = _ref.city,
    state = _ref.state,
    logo = _ref.logo,
    to = _ref.to,
    cover = _ref.cover,
    coverFallback = _ref.coverFallback;
  var _useStyle = useStyle(),
    coverStyle = _useStyle.coverStyle,
    logoStyle = _useStyle.logoStyle,
    rootStyle = _useStyle.rootStyle,
    coverContainerStyle = _useStyle.coverContainerStyle;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var trackNavigateToSchoolPage = useCallback(function () {
    trackEvent({
      event: 'Programs Page - Clicked Schools Page'
    });
  }, [trackEvent]);
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    className: rootStyle
  }, /*#__PURE__*/React.createElement(Box, {
    className: coverContainerStyle,
    display: ['block', undefined, 'flex']
  }, cover && coverFallback && /*#__PURE__*/React.createElement(ImageWithFallback, {
    alt: "school-cover",
    src: cover,
    srcFallback: coverFallback,
    loading: "lazy",
    className: coverStyle
  }), logo && /*#__PURE__*/React.createElement("img", {
    alt: "school logo",
    src: logo,
    className: logoStyle
  }), /*#__PURE__*/React.createElement(Box, {
    mt: {
      xs: 7,
      md: 0
    },
    mx: {
      xs: 3,
      md: 2
    },
    display: ['block', undefined, 'flex'],
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, null, !to ? /*#__PURE__*/React.createElement(Typography, null, schoolName) : /*#__PURE__*/React.createElement(StyledLink, {
    href: to,
    rel: "noopener noreferrer",
    target: "_blank",
    onClick: trackNavigateToSchoolPage
  }, /*#__PURE__*/React.createElement(Box, {
    display: displayMobileOnly,
    component: "span",
    marginRight: 1
  }, /*#__PURE__*/React.createElement(ArrowLeftOutlineIcon, null)), schoolName), /*#__PURE__*/React.createElement(Information, {
    display: {
      xs: 'none',
      md: 'flex'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    ml: "0"
  }, [city, state, countryCode].filter(Boolean).join(', ')))))));
};